export const ConfettiSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            className={className}
        >
            <path
                d="M3.26807 3.27197L6.804 3.27197"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.03589 1.50049L5.03589 5.04381"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5278 1.50049L15.6438 5.04381"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.0195 3.27197L31.5555 3.27197"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.7876 1.50049L29.7876 5.04381"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.7157 10.3589L20.9478 12.1305"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.0195 17.4454L31.5555 16.5596"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.0195 28.0757L31.5555 28.0757"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.7876 26.3037L29.7876 29.847"
                stroke="#FB5950"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.9508 23.678L9.42714 12.1304L1.66576 29.1029C1.51236 29.4324 1.46385 29.8013 1.52684 30.1594C1.58982 30.5175 1.76124 30.8475 2.01783 31.1046C2.27441 31.3617 2.60374 31.5335 2.9611 31.5966C3.31846 31.6597 3.68654 31.6111 4.01539 31.4574L20.9508 23.678Z"
                stroke="#08172B"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
